import { chakra } from "@chakra-ui/react";
import * as React from "react";

export const X = (props: any) => (
  <chakra.svg
    width="28px"
    height="29px"
    viewBox="0 0 28 29"
    fill="none"
    flexShrink={0}
    {...props}
  >
    <path
      d="M16.0952 12.5529L24.2865 3.23633H22.3461L15.2306 11.3241L9.55162 3.23633H3L11.5896 15.4677L3 25.2363H4.94041L12.4498 16.6935L18.4485 25.2363H25.0001M5.64074 4.66807H8.62175L22.3447 23.8749H19.3629"
      fill="#BB5D82"
    />
  </chakra.svg>
);
